import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SegmentTitle from '@components/entity/info/drawer/form/form-tab/segment-title';
import UnstyledHeading from '@shared/unstyled-heading';
import '../forms/forms.scss';

const DrawerSectionTitle = ({ tab, readOnly }) => {
  if (tab.type === 'segment') {
    return (
      <div>
        <div styleName="form-title form-stepper-title" id={`tab-section-${tab.id}-title`}>
          <UnstyledHeading rank={3} routeFocusSkip styleName="form-title-label-large">
            {tab.label}
          </UnstyledHeading>
        </div>
        <SegmentTitle readOnly={readOnly} tab={tab} />
      </div>
    );
  } else if (tab.type === 'subheader') {
    return (
      <div styleName="form-title" id={`tab-section-${tab.id}-title`}>
        <UnstyledHeading rank={3} routeFocusSkip styleName="form-title-label-subheader">
          {tab.label}
        </UnstyledHeading>
      </div>
    );
  }
  return (
    <div styleName="form-title form-stepper-title" id={`tab-section-${tab.id}-title`}>
      <UnstyledHeading rank={3} routeFocusSkip styleName="form-title-label-large">
        {tab.label}
      </UnstyledHeading>
      {tab.extra && (
        <div styleName="form-title-label-extra">
          {tab.extra}
        </div>
      )}
    </div>
  );
};

DrawerSectionTitle.propTypes = {
  readOnly: PropTypes.bool,
  tab: PropTypes.object
};

export default memo(DrawerSectionTitle);
